import React from 'react'
import { RouteObject } from 'react-router-dom'
import ProjectTemplateListPage from './project-template-list'
import ProjectTemplateShowPage from './project-template-show'

export enum projectPaths {}

export const projectRoutes: RouteObject[] = []
